export const API_KEY = "7468ee6c4373446cbea7dbba0940c903";

export const BASE_URL = "https://newsapi.org/v2/everything?language=tr";

export const GET_ALL_NEWS = "GET_ALL_NEWS";

export const GET_THE_NEWS = "GET_THE_NEWS";
